// extracted by mini-css-extract-plugin
export default {"cls1":"ViewAllSuggestions-cls1_E4d","cls2":"ViewAllSuggestions-cls2_I0O ViewAllSuggestions-cls1_E4d"};